/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
// import ReactDOMServer from "react-dom/server";
import { useReactToPrint } from "react-to-print";
import thaiBahtText from "thai-baht-text";
import "./MyPrint.css";
import logo from "../../../assets/images/Logo-AI.png";

import QuotationService from "../../../service/Quotation.service";
import {
  Button,
  Card,
  Flex,
  Table,
  Typography,
  message,
  Space,
  Spin,
} from "antd";
import { column } from "./model";

import dayjs from "dayjs";
// import { comma } from '../../../utils/util';
import { PiPrinterFill } from "react-icons/pi";
import { LoadingOutlined } from "@ant-design/icons";
import { comma } from "../../../utils/util";

const quoservice = QuotationService();

function POPrintPreview() {
  const { code } = useParams();
  const componentRef = useRef(null);
  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => handleBeforePrint(),
    onAfterPrint: () => handleAfterPrint(),
    removeAfterPrint: true,
  });

  const [hData, setHData] = useState({});
  const [details, setDetails] = useState([]);

  const [newPageContent, setNewPageContent] = useState([]);
  const columnDesc = column;

  const [loading, setLoading] = useState(false);

  const handleAfterPrint = () => {
    setNewPageContent([]);
  };
  const handleBeforePrint = (e) => {
    console.log("before printing...");
  };

  const handleCheckMultiPages = async () => {
    const limitPage = 550;
    return new Promise((r) => {
      // const head = document.querySelector("#raw .in-head");
      const data = document.querySelector("#raw .in-data");
      const table = document.querySelector("#raw .in-data #tb-data");
      // const thead = table?.querySelector("thead");
      const mtbody = table?.querySelector("tbody");
      // const mtfoot = table?.querySelector("tfoot");
      const row = mtbody?.querySelectorAll("tr");

      const samplesPage = [];
      // console.log(mtfoot);
      // console.log(componentRef.current);
      // let pageCount = 1;
      let hPageCheck = 0;
      let emlContent = [];
      for (let elm of row) {
        const h = Number(
          window
            .getComputedStyle(elm)
            .getPropertyValue("height")
            ?.replace("px", "")
        );
        if (hPageCheck + h > limitPage) {
          // console.log( { hPageCheck } );
          samplesPage.push([...emlContent, elm]);
          emlContent = [];
          hPageCheck = 0;
        } else {
          hPageCheck += h;
          emlContent = [...emlContent, elm];
        }

        // console.log( h, hPageCheck );
      }
      if (emlContent.length > 0) samplesPage.push(emlContent);

      // const hfoot = Number(window.getComputedStyle(mtfoot).getPropertyValue('height')?.replace("px", ""));
      const pages = [];
      for (let rind in samplesPage) {
        // const chead = head.cloneNode(true);
        const cdata = data.cloneNode(true);
        const table = cdata.querySelector("#tb-data");
        // const thead = table?.querySelector("thead");
        const tbody = table?.querySelector("tbody");
        const tfoot = table?.querySelector("tfoot");

        // tbody.style.height = `${limitPage - hfoot}px`;

        tbody.innerHTML = `${samplesPage[rind]
          .map((m) => m.outerHTML)
          .join("")}`;

        if (rind < samplesPage.length - 1) tfoot.remove();
        // else {
        //     tbody.innerHTML = `${tbody.innerHTML}<tr><td colspan='6' style="height:100%">&nbsp;</td></tr>`;
        // }
        const temp = document.createElement("div");

        // temp.appendChild( chead );
        temp.appendChild(cdata);
        temp.classList.add("on-page");
        pages.push(temp);
      }
      // console.log( pages );
      setNewPageContent((state) => [...state, ...pages]);
      r(pages);
    });
  };
  const handlePrintMultiPages = () => {
    setLoading(true);
    handleCheckMultiPages().then((res) => {
      handlePrint(null, () => printRef.current);
      setLoading(false);
    });
  };

  useEffect(() => {
    const init = () => {
      quoservice
        .get(code)
        .then(async (res) => {
          const { header, detail } = res.data;

          setHData(header);
          setDetails(detail);
        })
        .catch((err) => {
          console.log(err);
          message.error("Error getting Quotation.");
        });
    };

    init();
    return () => {};
  }, []);

  const HeaderForm = ({ ...resProps }) => {
    return (
      <>
        <div className="print-head" style={{ height: 90 }}>
          <div className="print-title">
            <ContentHead {...resProps} />
          </div>
        </div>
        <ContentHead2 {...resProps} />
      </>
    );
  };

  const FooterForm = ({ page }) => {
    return (
      <div className="print-foot" style={{ height: 34 }}>
        <div className="print-title flex justify-end">
          <Flex className="mb-0">
            <Typography.Text className="text-sm min-w-8">Page</Typography.Text>
            <Typography.Text className="text-sm" strong>
              {page}
            </Typography.Text>
          </Flex>
        </div>
      </div>
    );
  };

  const QuotationSummary = () => {
    return (
      <>
        <Table.Summary.Row className="r-sum">
          <Table.Summary.Cell
            colSpan={2}
            rowSpan={2}
            className="!align-top text-summary "
            // style={{borderBottom: "1px solid"}}
          >
            <Flex vertical gap={12}>
              <Flex vertical gap={2}>
                <Typography.Text
                  className="tx-info"
                  style={{ display: "block", fontSize: 14 }}
                >
                  เงื่อนไขการชำระเงิน :
                </Typography.Text>
                <Typography.Text
                  className="tx-info text-center"
                  style={{ display: "block", fontSize: 14 }}
                >
                  {hData?.payment_term}
                </Typography.Text>
                <Typography.Text
                  className="tx-info"
                  style={{ display: "block", fontSize: 14 }}
                >
                  กำหนดส่งสินค้า : {dayjs(hData?.deldate).format("DD/MM/YYYY")}
                </Typography.Text>
              </Flex>
            </Flex>
          </Table.Summary.Cell>
          <Table.Summary.Cell
            colSpan={2}
            className="text-summary text-start !align-top"
          >
            <Typography.Text
              className="text-sm"
              style={{ display: "block", fontSize: 14 }}
            >
              รวมราคาทั้งสิ้น / Sub total
            </Typography.Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell className="text-summary text-end !align-top">
            <Typography.Text
              className="text-sm text-end"
              style={{ fontSize: 14 }}
            >
              {comma(Number(hData?.total_price || 0), 2, 2)}
            </Typography.Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row className="r-sum">
          <Table.Summary.Cell
            colSpan={2}
            className="text-summary text-start !align-top"
          >
            <Typography.Text
              className="text-sm"
              style={{ display: "block", fontSize: 14 }}
            >
              ภาษีมูลค่าเพิ่ม / VAT 7%
            </Typography.Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell className="text-summary text-end !align-top">
            <Typography.Text
              className="text-sm text-end"
              style={{ display: "block", fontSize: 14 }}
            >
              {comma(Number((7 * hData?.total_price) / 100 || 0))}
            </Typography.Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row className="r-sum rl">
          <Table.Summary.Cell
            colSpan={2}
            className="text-summary !align-top text-center !ps-0 !pt-1"
          >
            <Typography.Text
              className="text-sm"
              style={{ display: "block", fontSize: 14 }}
            >
              (
              {thaiBahtText(
                Number((7 * hData?.total_price) / 100) +
                  Number(hData?.total_price)
              )}
              )
            </Typography.Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell
            colSpan={2}
            className="text-summary text-start !align-top"
          >
            <Typography.Text
              className="text-sm"
              style={{ display: "block", fontSize: 14 }}
            >
              จำนวนเงินรวมทั้งสิ้น / Total
            </Typography.Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell className="text-summary text-end !align-top">
            <Typography.Text
              className="text-sm"
              style={{ display: "block", fontSize: 14 }}
            >
              {comma(
                Number((7 * hData?.total_price) / 100) +
                  Number(hData?.total_price),
                2,
                2
              )}
            </Typography.Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell
            index={0}
            colSpan={4}
            className="!align-top !ps-0"
          >
            <Flex vertical gap={12}>
              <Flex vertical gap={2}>
                <Typography.Text className="tx-title" strong>
                  หมายเหตุ :
                </Typography.Text>
                <pre className="tx-info m-0">{hData?.remark}</pre>
              </Flex>
            </Flex>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={2} className="!align-top">
            {"\u00A0"}
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={8} className="!align-top !ps-0 !pt-8">
            <Flex className="w-full" gap={32} justify={"center"}>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2} justify="center">
                  <div
                    className="w-full"
                    style={{
                      height: 32,
                      borderBottom: "1px solid var(---color--1)",
                    }}
                  >
                    {"\u00A0"}
                  </div>
                </Flex>
                <Flex gap={2} justify="center">
                  <Typography.Text
                    className="tx-info"
                    align="center"
                    strong
                    style={{ minWidth: 48 }}
                  >
                    ผู้สั่งซื้อสินค้า /Ordered by{" "}
                  </Typography.Text>
                  <Typography.Text className="tx-info">
                    {"\u00A0"}
                  </Typography.Text>
                </Flex>
              </Flex>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2}>
                  <div
                    className="w-full"
                    style={{
                      height: 32,
                      borderBottom: "1px solid var(---color--1)",
                    }}
                  >
                    {"\u00A0"}
                  </div>
                </Flex>
                <Flex gap={2} justify="center">
                  <Typography.Text
                    className="tx-info text-center"
                    strong
                    style={{ minWidth: 48 }}
                  >
                    ผู้จัดทำ /Issued by{" "}
                  </Typography.Text>
                </Flex>
                <Flex gap={2} justify="center">
                  <Typography.Text className="tx-info text-center" strong>
                    คุณ ปิยรัตน์ ลอยสุวงศ์
                  </Typography.Text>
                </Flex>
              </Flex>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2}>
                  <div
                    className="w-full"
                    style={{
                      height: 32,
                      borderBottom: "1px solid var(---color--1)",
                    }}
                  >
                    {"\u00A0"}
                  </div>
                </Flex>
                <Flex gap={2} justify="center">
                  <Typography.Text
                    className="tx-info text-center"
                    strong
                    style={{ minWidth: 48 }}
                  >
                    ผู้อนุมัติ /Approver{" "}
                  </Typography.Text>
                </Flex>
                <Flex gap={2} justify="center">
                  <Typography.Text className="tx-info text-center" strong>
                    คุณ คุณากร กิติวรรโณ
                  </Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={8} className="!align-top !ps-0 !pt-3">
            <Flex className="w-full" gap={32} justify={"center"}>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2} justify="center" className="w-full font-bold">
                  <Typography.Text className="tx-info" strong>
                    วันที่ /Date
                    .............................................................................
                  </Typography.Text>{" "}
                </Flex>
              </Flex>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2} justify="center" className="w-full font-bold">
                  <Typography.Text className="tx-info" strong>
                    วันที่ /Date
                    .............................................................................
                  </Typography.Text>{" "}
                </Flex>
              </Flex>
              <Flex vertical className="w-1/3" style={{ gap: 10 }}>
                <Flex gap={2} justify="center" className="w-full font-bold">
                  <Typography.Text className="tx-info" strong>
                    Tel. 080 – 266 0934
                  </Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </>
    );
  };

  const ContentHead = () => {
    return (
      <div className="content-head in-sample flex flex-col">
        <div className="print-title flex pb-2">
          <div className="flex ps-3 grow-0" style={{ width: 600 }}>
            <Flex className="mb-1.5" vertical>
              <div className="grow pb-2">
                <img
                  src={logo}
                  alt=""
                  style={{
                    height: "100%",
                    width: 240,
                    float: "left",
                    marginLeft: "-25px",
                  }}
                />
              </div>
              <Typography.Text
                className="tx-title min-w-48 weight600"
                style={{ fontSize: 18 }}
                strong
              >
                บริษัท เอ.ไอ. โซลูชั่นเซอร์วิส จำกัด สำนักงานใหญ่
              </Typography.Text>
              <Typography.Text style={{ fontSize: 16 }}>
                29/2 หมู่ที่ 3 ตำบลศาลาครุ อำเภอหนองเสือ จังหวัดปทุมธานี 12170
              </Typography.Text>
            </Flex>
          </div>
          <div className="flex ps-3 grow-0" style={{ width: 600 }}>
            <Flex className="mb-1.5" vertical style={{ paddingTop: "35px" }}>
              <Typography.Text
                className="tx-title min-w-48 weight600"
                style={{ fontSize: 26 }}
                strong
              >
                A.I. Solution Service Co., Ltd.
              </Typography.Text>
              <Typography.Text style={{ fontSize: 16 }}>
                29/2 Moo3, Sala Khru ,Nong Suea,Pathum Thani 12170
              </Typography.Text>
              <Typography.Text style={{ fontSize: 16 }}>
                Line ID : @golf_ai. Tel. 080-2660934 (อ้น)
              </Typography.Text>
              <Typography.Text style={{ fontSize: 16 }}>
                E-maill A.I.SolutionService15@gmail.com
              </Typography.Text>
            </Flex>
          </div>
        </div>
      </div>
    );
  };

  const ContentHead2 = () => {
    return (
      <div className="head-data" style={{ paddingTop: "80px" }}>
        <div className="text-center">
          <Typography.Title level={3} className="uppercase">
            <Flex align="center" gap={1} vertical>
              <Typography.Text ellipsis style={{ fontSize: 26 }}>
                ใบเสนอราคา
              </Typography.Text>
              <Typography.Text ellipsis style={{ fontSize: 26 }}>
                QUOTATION
              </Typography.Text>
            </Flex>
          </Typography.Title>
        </div>
        <div className="flex">
          <div
            className="flex w-3/4 flex-col"
            style={{ border: "1px solid", paddingInline: 15 }}
          >
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                ชื่อลูกค้า/Customer :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {" "}
                {hData?.prename} {hData?.cusname}
              </Typography.Text>
            </Space>
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                ที่อยู่/Address :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {hData.address}
              </Typography.Text>
            </Space>
            <div className="flex">
              <div className="flex w-1/2 flex-col">
                <Space className="w-full items-baseline">
                  <Typography.Text strong ellipsis style={{ fontSize: 14 }}>
                    {/* เลขผู้เสียภาษี/Tax ID */}
                  </Typography.Text>
                  {/* <Typography.Text>{hData.spname}</Typography.Text> */}
                </Space>
              </div>
              <div className="flex w-1/2 flex-col">
                <Space className="w-full items-baseline">
                  <Typography.Text strong ellipsis style={{ fontSize: 14 }}>
                    {/* สำนักงานใหญ่ */}
                  </Typography.Text>
                  <Typography.Text style={{ display: "block", fontSize: 14 }}>
                    {/* {hData.spname} */}
                  </Typography.Text>
                </Space>
              </div>
            </div>
            <div className="flex" style={{ margin: "0px" }}>
              <div className="flex w-1/2 flex-col">
                <Space className="w-full items-baseline">
                  <Typography.Text
                    strong
                    style={{ display: "block", width: 128, fontSize: 14 }}
                    width={124}
                  >
                    ผู้ติดต่อ/Contact :
                  </Typography.Text>
                  <Typography.Text style={{ display: "block", fontSize: 14 }}>
                    {hData.contact}
                  </Typography.Text>
                </Space>
              </div>
              <div className="flex w-1/2 flex-col">
                <Space className="w-full items-baseline">
                  <Typography.Text strong ellipsis style={{ fontSize: 14 }}>
                    โทร/Tel. :
                  </Typography.Text>
                  <Typography.Text style={{ display: "block", fontSize: 14 }}>
                    {hData.tel}
                  </Typography.Text>
                </Space>
              </div>
            </div>
            <Space className="w-full items-baseline" style={{ margin: "0px" }}>
              <Typography.Text strong ellipsis style={{ fontSize: 14 }}>
                อีเมลล์/E-Mail :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {hData.email}
              </Typography.Text>
            </Space>
          </div>
          <div
            className="flex w-3/4 flex-col"
            style={{
              borderRight: "1px solid",
              borderTop: "1px solid",
              borderBottom: "1px solid",
              paddingInline: 15,
            }}
          >
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                เลขที่/No :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {hData.qtcode}
              </Typography.Text>
            </Space>
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                วันที่/Date :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {dayjs(hData?.qtdate).format("DD/MM/YYYY")}
              </Typography.Text>
            </Space>
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                ยืนราคา/Valid Price :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                30 วัน
              </Typography.Text>
            </Space>
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 128, fontSize: 14 }}
                width={124}
              >
                ใช้ได้ถึง/Valid Date :
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 14 }}>
                {dayjs(hData?.qtdate).add(30, "days").format("DD/MM/YYYY")}
              </Typography.Text>
            </Space>
          </div>
        </div>
      </div>
    );
  };

  const ContentBody = () => {
    return (
      <div className="content-body in-data flex flex-col">
        <Card
          size="small"
          bordered
        >
          <Table
            id="tb-data"
            size="small"
            dataSource={details}
            columns={columnDesc}
            pagination={false}
            rowKey="stcode"
            bordered={false}
            locale={{
              emptyText: <span>No data available, please add some data.</span>,
            }}
            onRow={(record, index) => {
              return { className: "r-sub" };
            }}
            summary={QuotationSummary}
          />
        </Card>
      </div>
    );
  };

  const Pages = () => (
    <div ref={componentRef} id="raw">
      <ContentData>
        <ContentBody />
      </ContentData>
    </div>
  );

  const ContentData = ({ children, pageNum = 0, total = 0 }) => {
    return (
      <div className="quo-pages flex flex-col">
        <HeaderForm page={`${pageNum}/${total}`} />
        <div className="print-content grow">{children}</div>
        <FooterForm page={`${pageNum} of ${total}`} />
      </div>
    );
  };

  return (
    <>
      {/* <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, }} spin />} fullscreen /> */}
      <div className="page-show" id="quo">
        {loading && <Spin fullscreen indicator={<LoadingOutlined />} />}
        <div className="title-preview">
          <Button
            className="bn-center  bg-blue-400"
            onClick={() => {
              handlePrintMultiPages();
            }}
            icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
          >
            PRINT
          </Button>
        </div>
        <div className="layout-preview">
          <Pages />
        </div>
        <div className="hidden" id="mypage">
          <div ref={printRef}>
            {newPageContent?.map((page, i) => {
              // console.log( page.innerHTML );
              return (
                <div key={i} className="on-page">
                  <ContentData pageNum={i + 1} total={newPageContent?.length}>
                    <div
                      dangerouslySetInnerHTML={{ __html: page.innerHTML }}
                    ></div>
                  </ContentData>
                  {i < newPageContent.length - 1 && (
                    <div className="page-break"></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default POPrintPreview;
